import React from "react";

const NotFound = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh", flexDirection: "column" }}>
      <h1 style={{ fontSize: "72px", margin: "0", color: "#333" }}>404</h1>
      <p style={{ fontSize: "18px", color: "#666" }}>Page not found</p>
    </div>
  );
};

export default NotFound;
